import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from "vue";
import {
  adminApiStore,
  orgApiStore,
  orgStore,
  permissionStore,
  sessionApiStore,
} from "@/hooks";
import {
  PanelCard,
  TextButton,
  Typography,
  ExpansionItem,
  TextInput,
  SelectInput,
  EmailInput,
} from "@/components/common";


/**
 * Displays controls for admins.
 */
const __default__ = {
  name: "AdminControls",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const adminCreateEmail = ref("");
const adminCreatePassword = ref("");
const adminSuperuserEmail = ref("");
const adminResetEmail = ref("");

/**
 * As an admin, creates a pre-verified account.
 */
function handleAdminCreate() {
  sessionApiStore.handleCreateAccount(
    {
      email: adminCreateEmail.value,
      password: adminCreatePassword.value,
    },
    true
  );
}

/**
 * As an admin, sets an account as a superuser.
 */
function handleAdminSuperuser() {
  adminApiStore.enableSuperuser({
    email: adminSuperuserEmail.value,
  });
}

/**
 * As an admin, sets an account to recurring billing to allow generation.
 */
function handleEnableGeneration() {
  adminApiStore.updatePaymentTier(orgStore.org, "RECURRING");
}

/**
 * As an admin, resets the password of the given account.
 */
function handleResetPassword() {
  adminApiStore.handleAdminPasswordReset(adminResetEmail.value);
}

return (_ctx: any,_cache: any) => {
  const _component_q_toggle = _resolveComponent("q-toggle")!

  return (_unref(permissionStore).isSuperuser)
    ? (_openBlock(), _createBlock(_unref(PanelCard), {
        key: 0,
        title: "Admin Controls"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toggle, {
            modelValue: _unref(adminApiStore).activeSuperuser,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(adminApiStore).activeSuperuser) = $event)),
            class: "q-ma-md"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Typography), {
                value: "Superuser mode",
                el: "div"
              }),
              _createVNode(_unref(Typography), {
                secondary: "",
                value: "Enables all permissions"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(ExpansionItem), {
            label: "Create Account",
            disable: !_unref(adminApiStore).activeSuperuser
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(EmailInput), {
                modelValue: adminCreateEmail.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((adminCreateEmail).value = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(TextInput), {
                modelValue: adminCreatePassword.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((adminCreatePassword).value = $event)),
                label: "Password"
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(TextButton), {
                block: "",
                outlined: "",
                disabled: !adminCreateEmail.value || !adminCreatePassword.value,
                color: "primary",
                label: "Create Account",
                icon: "invite",
                onClick: handleAdminCreate
              }, null, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["disable"]),
          _createVNode(_unref(ExpansionItem), {
            label: "Enable Superuser",
            disable: !_unref(adminApiStore).activeSuperuser
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(EmailInput), {
                modelValue: adminSuperuserEmail.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((adminSuperuserEmail).value = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(TextButton), {
                block: "",
                outlined: "",
                color: "primary",
                label: "Enable Superuser",
                icon: "invite",
                onClick: handleAdminSuperuser
              })
            ]),
            _: 1
          }, 8, ["disable"]),
          _createVNode(_unref(ExpansionItem), {
            label: "Enable Generation",
            disable: !_unref(adminApiStore).activeSuperuser
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SelectInput), {
                modelValue: _unref(orgApiStore).currentOrg,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(orgApiStore).currentOrg) = $event)),
                options: _unref(orgStore).allOrgs,
                label: "Organization",
                "option-value": "id",
                "option-label": "name",
                class: "q-mb-md"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_unref(TextButton), {
                block: "",
                outlined: "",
                color: "primary",
                label: "Enable Generation",
                icon: "invite",
                onClick: handleEnableGeneration
              })
            ]),
            _: 1
          }, 8, ["disable"]),
          _createVNode(_unref(ExpansionItem), {
            label: "Reset Password",
            disable: !_unref(adminApiStore).activeSuperuser
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(EmailInput), {
                modelValue: adminResetEmail.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((adminResetEmail).value = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(TextButton), {
                block: "",
                outlined: "",
                color: "primary",
                label: "Reset Password",
                icon: "redo",
                onClick: handleResetPassword
              })
            ]),
            _: 1
          }, 8, ["disable"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})